<template>
  <div class="video-lightbox"
    :class="{
      'video-lightbox--small-display': smallDisplay
    }"
    :style="lightboxStyle"
    @mousewheel.prevent.stop
    @click.self.stop="handleClose"
    @touchstart.self.prevent.stop="handleClose">
  <div class="video-lightbox__constraint"
    @mousewheel.prevent.stop
    @click.self.stop="handleClose"
    @touchstart.self.prevent.stop="handleClose"
    :style="constraintStyle">
    <div class="video-lightbox__wrapper"
      :style="wrapperStyle">
      <VideoPlayer
        class="video-lightbox__hero-video"
        :src="heroVideoConfig.src"
        :id="heroVideoConfig.id"
        :controlBar="heroVideoConfig.controlBar"
        :aspectRatio="heroVideoConfig.aspectRatio"
        @close="handleClose"
      />
    </div>
  </div>
  </div>
</template>

<script>
/**
 * Lightbox component for viewing a video
 *
 * Submission expanded view
 */
import {
  mapMutations, mapGetters, mapState
} from 'vuex';
import VideoPlayer from './../components/video-player';
import LightboxSize from './../mixins/lightbox-size';
import {
  HERO_VIDEO_CONFIG
} from '../core/config';
import { UI_HERO_VIDEO_VISIBLE } from './../core/store/mutation-types';

export default {
  name: 'video-lightbox',
  props: {
  },
  mixins: [LightboxSize],
  components: {
    VideoPlayer,
  },
  data() {
    return {
      heroVideoConfig: HERO_VIDEO_CONFIG,
    };
  },
  computed: {
    /**
     * The proper top and height
     *
     * @returns {*} ready for binding to style
     */
    lightboxStyle() {
      return {
        top: `${this.scrollTop}px`,
        height: `${this.viewportHeight}px`,
      };
    },
    /**
     * Use the small display version
     */
    smallDisplay() {
      return this.mediaMedium || this.mediaSmall;
    },

    /**
     * Dimensions of lightbox content
     *
     * @returns {*}
     */
    contentDimensions() {
      const {
        height,
        width
      } = this.heroVideoConfig;

      return {
        height,
        width
      };
    },

    /**
     * The constraining box around the submissions
     */
    constraintStyle() {
      // const maxHeight = this.viewportHeight * NUMBER_HEIGHT_LIGHTBOX_MAX_RAW;
      // const maxWidth = this.viewportWidth * NUMBER_WIDTH_LIGHTBOX_MAX_RAW;

      // return {
      //   maxHeight: `${maxHeight}px`,
      //   maxWidth: `${maxWidth}px`
      // };
      return {};
    },

    ...mapGetters('windowMedia', [
      'viewportHeight',
    ]),
    ...mapState('windowMedia', [
      'mediaMedium',
      'mediaSmall',
      'scrollTop',
    ]),
  },
  watch: {
    /**
     * if we switch display styles there's a possibility that the lightbox will get cut off by the new, shorter iframe.
     */
    smallDisplay(value) {
      if (value) {
        this.handleClose();
      }
    }
  },
  methods: {
    handleClose() {
      this.setHeroVideoVisible({ visible: false });
    },
    ...mapMutations({
      setHeroVideoVisible: UI_HERO_VIDEO_VISIBLE,
    })
  }
};
</script>

<style lang="scss">
.video-lightbox {
  z-index: $z-index-lightbox;
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $color-background-submission-lightbox;


  &__constraint {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: {
      top: $size-margin-top-video-lightbox-constraint-large;
      left: $size-margin-video-lightbox-constraint-large;
      right: $size-margin-video-lightbox-constraint-large;
      bottom: $size-margin-bottom-video-lightbox-constraint-large;
    }
  }

  &__wrapper {
    position: relative;

    // background: pink;

    /// TODO: temp, need a lightbox component or like a style
    .video-player {

      // position: relative;
      // top: initial;
      // left: initial;
      &,
      &__video {
        width: 100%;
        max-width: none;
        max-height: none;

        // old styles from miles

        //     width: 80%;
        // height: auto;
        // max-width: $size-width-hero-video;
        // max-height: $size-height-hero-video;
      }
    }

    .submission-image {
      flex: 1 1 auto;
      max-height: 100%;
    }
  }

  &--small-display {
  .video-lightbox {
      &__constraint {
        padding: {
          top: $size-margin-top-video-lightbox-constraint-small;
          left: $size-margin-video-lightbox-constraint-small;
          right: $size-margin-video-lightbox-constraint-small;
          bottom: $size-margin-bottom-video-lightbox-constraint-small;
        }
      }
    }
  }
}
</style>
